import type {
  Configuration,
  CreateThreatHuntingScanRequestRequest,
  ListThreatHuntingResultsRequest,
  ListThreatHuntingScanRequestsRequest,
  UpdateThreatHuntingScanRequestRequest,
} from '@repo/api-gw-sdk';
import { ThreatHuntingApi } from '@repo/api-gw-sdk';

import { encodePageToken } from '@/utils/string';

import type { HttpClient } from './httpClient';

const baseUrl = '/threat-hunting';

export const threatHunting = (
  httpClient: HttpClient,
  config: Configuration,
  currentProjectId: string
) => {
  const threatHuntingApi = new ThreatHuntingApi(config);

  return {
    scanRequests: {
      // A null body matches no scan request, so nothing is fetched.
      useList: ({
        body,
        pageIndex,
        pageSize,
      }: {
        body: ListThreatHuntingScanRequestsRequest | null;
        pageIndex: number;
        pageSize: number;
      }) =>
        httpClient.execute(
          threatHuntingApi.listThreatHuntingScanRequests.bind(threatHuntingApi),
          body === null ? null : baseUrl,
          'scan-requests',
          currentProjectId,
          pageIndex > 0 ? encodePageToken(pageIndex) : undefined,
          pageSize,
          body ?? undefined
        ),
      create: (body: CreateThreatHuntingScanRequestRequest) =>
        threatHuntingApi.createThreatHuntingScanRequest(currentProjectId, body),
      update: (
        requestId: string,
        body: UpdateThreatHuntingScanRequestRequest
      ) =>
        threatHuntingApi.updateThreatHuntingScanRequest(
          currentProjectId,
          requestId,
          body
        ),
      remove: (requestId: string) =>
        threatHuntingApi.deleteThreatHuntingScanRequest(
          currentProjectId,
          requestId
        ),
    },
    results: {
      useList: (
        body?: ListThreatHuntingResultsRequest,
        pageToken?: string,
        pageSize?: number
      ) =>
        httpClient.execute(
          threatHuntingApi.listThreatHuntingResults.bind(threatHuntingApi),
          baseUrl,
          'results',
          currentProjectId,
          pageToken,
          pageSize,
          body
        ),
      list: (
        body: ListThreatHuntingResultsRequest,
        pageToken?: string,
        pageSize?: number
      ) =>
        threatHuntingApi.listThreatHuntingResults(
          currentProjectId,
          pageToken,
          pageSize,
          body
        ),
    },
  };
};
